module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"chartHeaderTooltip":"Ranking pod względem liczby dostępnych ofert w sklepach dla produktu."}}')
  delete Component.options._Ctor
}
